import React from 'react'
import Voitng from "../Component/Voting";

function ClassClash() {
  return (
    <div>

      
      
      <Voitng/>


    
    
    
    </div>
  )
}

export default ClassClash